import {assert} from 'assert-ts';
import type {ExpressionV4, Metadata} from '../types';
import type {MetadataEditAction} from '../metadataEditActionTypes';

export const assertExpression = (
  expressionId: string,
  metadata: Metadata | undefined,
  action?: MetadataEditAction,
  qualifer?: 'saved' | 'edit',
): ExpressionV4 => {
  const expression = metadata?.expressions.find(e => e.id === expressionId);

  if (!expression) {
    assert(
      false,
      qualifer
        ? `metadataEditReducer.assertExpression (${qualifer}): expression "${expressionId}" not found`
        : `metadataEditReducer.assertExpression: expression "${expressionId}" not found`,
      action,
    );
  }

  return expression;
};
